import "core-js/stable";
import "regenerator-runtime/runtime";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/features/promise";
import "core-js/features/string/repeat";
import "core-js/features/string/includes";
import "formdata-polyfill";
import smoothscroll from "smoothscroll-polyfill";
import environment from "environment";
import { createBrowserHistory, History } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Store } from "redux";
import "./index.scss";
import IStore from "./models/IStore";
import * as serviceWorker from "./serviceWorker";
import rootStore from "./stores/rootStore";
import App from "./views/App";
require("typeface-ibm-plex-sans");

smoothscroll.polyfill();
const initialState: Partial<IStore> = {};
export const history: History = createBrowserHistory({ basename: environment.route.baseRoute });
export const store: Store<IStore> = rootStore(initialState, history);

(async (window: Window): Promise<void> => {
    const rootEl: HTMLElement | null = document.getElementById("root");
    const render = (Component: typeof App, el: HTMLElement | null): void => {
        ReactDOM.render(
            <Provider store={store}>
                <Component history={history} dispatch={store.dispatch} />
            </Provider>,
            el
        );
    };

    render(App, rootEl);
})(window);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
